import { attachDesktopMouseDrag, getHorizontalStep, updateHorizontalNavState } from "../homepage/scroller-utils";

const initProduct26ProfessionalProof = () => {
  const scroller = document.querySelector(
    ".professional-proof--product-26 [data-manual-reviews-scroller]"
  );

  if (!scroller || scroller.dataset.manualReviewsInitialized === "true") {
    return;
  }

  const section = scroller.closest("[data-manual-reviews-id]");
  const prevButton = section ? section.querySelector("[data-manual-reviews-prev]") : null;
  const nextButton = section ? section.querySelector("[data-manual-reviews-next]") : null;
  const items = Array.from(scroller.querySelectorAll(".manual-review"));

  if (!items.length) {
    return;
  }

  scroller.dataset.manualReviewsInitialized = "true";

  let resizeTimer = null;
  let scrollEndTimer = null;

  const getStep = () => getHorizontalStep(scroller, items[0]);

  const updateNavState = () => updateHorizontalNavState(scroller, prevButton, nextButton);

  const equalizeContainerHeights = () => {
    const contentElements = items
      .map((item) => item.querySelector(".review-content"))
      .filter(Boolean);

    contentElements.forEach((contentElement) => {
      contentElement.style.minHeight = "";
    });

    let tallestContentHeight = 0;
    contentElements.forEach((contentElement) => {
      tallestContentHeight = Math.max(
        tallestContentHeight,
        contentElement.getBoundingClientRect().height
      );
    });

    if (tallestContentHeight > 0) {
      const targetContentHeight = `${Math.ceil(tallestContentHeight)}px`;
      contentElements.forEach((contentElement) => {
        contentElement.style.minHeight = targetContentHeight;
      });
    }
  };

  const scrollByStep = (direction) => {
    scroller.scrollBy({
      left: getStep() * direction,
      behavior: "smooth",
    });
  };

  const handleScroll = () => {
    updateNavState();
    window.clearTimeout(scrollEndTimer);
    scrollEndTimer = window.setTimeout(() => {
      equalizeContainerHeights();
    }, 120);
  };

  const handleResize = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      updateNavState();
      equalizeContainerHeights();
    }, 120);
  };

  if (prevButton && nextButton) {
    prevButton.addEventListener("click", () => scrollByStep(-1));
    nextButton.addEventListener("click", () => scrollByStep(1));
  }

  attachDesktopMouseDrag(scroller, { imageSelector: ".manual-review img" });

  scroller.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("resize", handleResize);

  updateNavState();
  equalizeContainerHeights();
  window.setTimeout(equalizeContainerHeights, 0);
};

const initCompanyProofV2 = () => {
  const track = document.querySelector('[data-company-proof-v2-track]');

  if (!track || track.dataset.companyProofV2Initialized === 'true') {
    return;
  }

  const section = track.closest('[data-company-proof-v2-id]');
  const prevButton = section ? section.querySelector('[data-company-proof-v2-prev]') : null;
  const nextButton = section ? section.querySelector('[data-company-proof-v2-next]') : null;
  const cards = Array.from(track.querySelectorAll('.company-proof-v2__card'));

  if (!cards.length) {
    return;
  }

  track.dataset.companyProofV2Initialized = 'true';

  let resizeTimer = null;

  const getStep = () => getHorizontalStep(track, cards[0]);

  const updateNavState = () => {
    if (window.innerWidth >= 1920) {
      if (prevButton) prevButton.hidden = true;
      if (nextButton) nextButton.hidden = true;
      return;
    }

    updateHorizontalNavState(track, prevButton, nextButton);
  };

  const scrollByStep = (direction) => {
    if (window.innerWidth >= 1920) {
      return;
    }

    track.scrollBy({
      left: getStep() * direction,
      behavior: 'smooth',
    });
  };

  const handleResize = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      updateNavState();
    }, 120);
  };

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => scrollByStep(-1));
    nextButton.addEventListener('click', () => scrollByStep(1));
  }

  attachDesktopMouseDrag(track, { imageSelector: '.company-proof-v2__card img' });

  track.addEventListener('scroll', updateNavState, { passive: true });
  window.addEventListener('resize', handleResize);

  updateNavState();
  window.setTimeout(updateNavState, 0);
};

const productPageCarousels = () => {
  const isProductTemplate26 = document.body.classList.contains('product-product-26');
  // const ingredients = document.getElementsByClassName('product-ingredients')

  $(function () {

    const $slider = $('.product-ingredients');
    const itemCount = $slider.children().length;

    if (isProductTemplate26) {
      document.querySelector('.product-ingredients__arrows')?.style.setProperty('display', 'none');
      return;
    }

    if (itemCount >= 3) {
      $slider.slick({
        dots: false,
        infinite: false,
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });
    } else if (itemCount === 2) {
      document.querySelector('.product-ingredients').style.justifyContent = "space-between";
      document.querySelector('.product-ingredients__arrows').style.display = "none";

      const ingredients = document.querySelectorAll('.product-ingredient');

      ingredients.forEach(ingredient => {
        ingredient.style.display = "flex";
        ingredient.style.width = "48%";
      });

    } else {
      document.querySelector('.product-ingredients__arrows').style.display = "none";
    }
  });

  if (isProductTemplate26) {
    initProduct26ProfessionalProof();
  } else {
    $('.professional-proof__people').slick({
      dots: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $('.prev-arrow--pp'),
      nextArrow: $('.next-arrow--pp'),
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

  $('.company-proof').slick({
    dots: false,
    infinite: false,
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.prev-arrow--cp'),
    nextArrow: $('.next-arrow--cp'),
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  initCompanyProofV2();

};

export default productPageCarousels;